import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectFindUserRoleStatus = createSelector(
  [(store: RootState) => store.massiveDocumentCreate.findUserRoleStatus],
  (status) => status
);
